export class PromoKeys {
  promoToken?: string;
}

export class PromoKeysName {
  promoToken = 'promotion_token';
}
